exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtotal-row[data-v-45ea4382] {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #dadde0;\n  padding: 25px 0 43px 0;\n}\n@media (max-width: 992px) {\n.subtotal-row[data-v-45ea4382] {\n    flex-direction: column;\n}\n}\n@media (max-width: 768px) {\n.subtotal-row .sub-total[data-v-45ea4382] {\n    flex-direction: column;\n}\n}", ""]);

// exports
